import { FilterTagsCondition } from 'dashboard/components/TagsConditionFilter';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { CheckStatus } from 'dashboard/models/check';
import { Environment } from 'dashboard/models/environment';
import { Inquiry, InquiryStatus } from 'dashboard/models/inquiry';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';
import { CheckName } from 'lib/verificationCheck';

interface InquiriesPayload {
  inquiries: Inquiry[];
  environment: Environment;
  paginationParams: PaginationParams;
}

export interface CheckFilterValues {
  check: CheckName;
  status: CheckStatus;
}

export interface InquiriesFilterParams {
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  status?: InquiryStatus[];
  templateIds?: string[];
  templateOrInquiryTemplateId?: string;
  tagsConditions?: FilterTagsCondition[][];
  tagIds?: string[];
  listIds?: string[];
  omni?: string;
  checks?: CheckFilterValues[];
  reusablePersonaUsed?: string;
}

interface InquiryFiltersPayload {
  filters: InquiriesFilterParams;
}

interface InquirySortParamsPayload {
  sortParams: SortParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

export type InquiriesActions =
  | Action<InquiriesActionType.SaveInquiries, InquiriesPayload>
  | Action<InquiriesActionType.SaveInquirySortParams, InquirySortParamsPayload>
  | Action<InquiriesActionType.SaveInquiryFilters, InquiryFiltersPayload>
  | Action<InquiriesActionType.SaveCurrentPage, CurrentPagePayload>
  | Action<InquiriesActionType.SavePageSize, PageSizePayload>;

export enum InquiriesActionType {
  SaveInquiries = 'inquiries/SAVE_INQUIRIES',
  SaveInquiryFilters = 'inquiries/SAVE_INQUIRY_FILTERS',
  SaveInquirySortParams = 'inquiries/SAVE_INQUIRY_SORT_PARAMS',
  SaveCurrentPage = 'inquiries/SAVE_CURRENT_PAGE',
  SavePageSize = 'inquiries/SAVE_PAGE_SIZE',
}

export function saveInquiries(
  inquiries: Inquiry[],
  environment: Environment,
  paginationParams: PaginationParams | undefined,
) {
  return {
    payload: {
      inquiries,
      environment,
      paginationParams,
    },
    type: InquiriesActionType.SaveInquiries,
  };
}

export function saveInquiryFilters(filters: InquiriesFilterParams) {
  return {
    payload: {
      filters,
    },
    type: InquiriesActionType.SaveInquiryFilters,
  };
}

export function saveInquirySortParams(sortParams: SortParams) {
  return {
    payload: {
      sortParams,
    },
    type: InquiriesActionType.SaveInquirySortParams,
  };
}

export function saveCurrentPage(currentPage: number) {
  return {
    payload: {
      currentPage,
    },
    type: InquiriesActionType.SaveCurrentPage,
  };
}

export function savePageSize(pageSize: number) {
  return {
    payload: {
      pageSize,
    },
    type: InquiriesActionType.SavePageSize,
  };
}
